import { render, staticRenderFns } from "./SithMomPjDocument.vue?vue&type=template&id=56fd26ac&scoped=true&"
import script from "./SithMomPjDocument.vue?vue&type=script&lang=js&"
export * from "./SithMomPjDocument.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56fd26ac",
  null
  
)

export default component.exports